// extracted by mini-css-extract-plugin
var _1 = "FFFErrorBoundary_content__-4hzt";
var _2 = "FFFErrorBoundary_errorPage__ULQcJ";
var _3 = "FFFErrorBoundary_imageWrapper__tYExV";
var _4 = "992px";
var _5 = "768px";
var _6 = "FFFErrorBoundary_separator__WinKL";
var _7 = "'../shared.module.css'";
export { _1 as "content", _2 as "errorPage", _3 as "imageWrapper", _4 as "lg", _5 as "md", _6 as "separator", _7 as "shared" }
